import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import Modal from 'react-modal';
import CurrentEdit from './CurrentEdit.js'; //component that contains the information of prize that is currently being edited
import loader from '../asset/img/loader.gif';

export default class EditPrizes extends Component {
	constructor(props){
		super(props);
		this.editPrize = this.editPrize.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.commitEdit = this.commitEdit.bind(this);
		this.putVariants = this.putVariants.bind(this);
		this.updateVariants = this.updateVariants.bind(this);
		this.updatePrize = this.updatePrize.bind(this);
		this.loadingFunc = this.loadingFunc.bind(this);
		this.state = {currentEdit:'',editedPrizes:[],failed:false,modalIsOpen:false,loading:false,done:false};
	}

	loadingFunc(loading){ //function to open modal and display loading gif
		if(loading){
			this.setState({loading:true},function(){
				this.openModal();
			});
		}else{
			this.setState({loading:false},function(){
				this.props.reset(this.props.year);
			});
		}
	}

	editPrize(e){	//method for selecting which prize/gift to be edited. passes down information to CurrentEdit component
		let ID = e.target.id;
		let prize;
		this.props.prizes.forEach((prizes)=>{
			if(Number(prizes.prizeID) === Number(ID)){
				prize = prizes;
			}
		});
		this.setState({currentEdit:prize},function(){
			this.openModal();
		});
	}

	updatePrize(p){ //method that handles api calls for updating all prize information
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'prizes',misc:'update',name:p.prize,secondID:p.tier,desc:p.description,quantity:p.cap,firstID:p.ID,status:p.status}
		});
	}

	putVariants(id,variants){
		variants.forEach((variant)=>{
			axios({
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:{endpoint:'create',table:'variants',misc:'create',firstID:id,secondID:this.props.year,status:variant.size,name:variant.color}
			});
		});
	}

	updateVariants(variants){ //method for updating the status of pize variants (active or inactive)
		let updated = [];
		variants.forEach(variant=>{
			updated.push(axios({
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:{endpoint:'create',table:'variants',misc:'status',firstID:variant.variantID,status:variant.status}
			}));
		});
		axios.all(updated).then(()=>{
			this.setState({modalPrompt:"Prize Updated!",done:true},function(){
				this.loadingFunc(false);
			});
		});
	}

	commitEdit(edited){ //begin process of saving edited information
		if(edited.ID !== 0){
			this.loadingFunc(true);
			this.updatePrize(edited);
			this.updateVariants(edited.variants);
		}else{
			this.setState({modalPrompt:"Sorry, there was a problem with your input. Please try again.",done:true},function(){
				this.openModal();
			});
		}
	}

	openModal() { //open the modal
    	this.setState({modalIsOpen: true});
  }

	closeModal() { //close the modal
	    this.setState({modalIsOpen: false,done:false});
	}

	componentDidUpdate(prevProps,prevState){ //dont believe this code is used anymore
		if(prevProps.save !== this.props.save && this.props.save){
			let edited = this.state.editedPrizes;
			edited.forEach((prize)=>{
				this.updatePrize(prize);
				this.updateVariants(prize.variants);
				if(prize.newVariants.length > 0){
					this.putVariants(prize.ID,prize.newVariants);
				}
			});
		}
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    maxWidth:'900px',
		    transform: 'translate(-50%, -50%)',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    backgroundColor:'#F4F4F4',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		let modalContent;
		const picstyles= {display:'block', maxWidth:'100px',maxHeight:'122px',width:'auto',height:'auto',margin:'auto'};
		let prizes;
		let pStyles = "mt0 pt3 fl w-100 b navy mb3 bb b--light-silver";
		prizes= this.props.prizes.map((prizes,i)=>{ //loop through and display all prizes/gifts
			const cap = prizes.cap === null?"none":prizes.cap;
			let photo = prizes.picture + prizes.variants[0].photo;
			photo = photo.replace(/\s/g,"_");
			return(<div className="fl w-50-ns mb2 w-100-m w-100 pa1" key={i}><div style={{maxWidth:'460px',margin:'auto',height:'250px'}} className="ba overflow-y-auto ma2 pa2 bw1 b--light-silver br3 shadow-3 bg-white">
							<div className="fl w-60" style={{minHeight:'200px',maxHeight:'200px'}}>
								<p className="mt0 pt2 tc b mr2">{prizes.prize}</p>
								<img src={photo} alt="error" style={picstyles} className="mr2"/>
								<p className="tc mr2">{prizes.description}</p>
							</div>
							<div className="fl w-40">
								<div className="fl w-100">
									<p className={pStyles}><span className="b">Tier: </span>{prizes.tier}</p>
									<p className={pStyles}><span className="b">Cap: </span>{cap}</p>
									<p className={pStyles}><span className="b">Status: </span>{prizes.status}</p>
									<button id={prizes.prizeID} onClick={this.editPrize} className="bg-navy b br2 mt2 pa1 white">Edit Prize</button>
								</div>
							</div>
						</div></div>);
			});
		if(this.state.loading){ //display loading gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else if(this.state.done){ //display message prompt
			modalContent = <p  className="tc b navy f3">{this.state.modalPrompt}</p>;
		}else{ //modal displays the CurrentEdit component
			modalContent = <CurrentEdit prize={this.state.currentEdit} onFinish={this.commitEdit} tiers={this.props.tiers}/>;
		}
		return(
			<div>
				<div>
					{prizes}
				</div>
				<div>
					<Modal
		          isOpen={this.state.modalIsOpen}
		          style={customStyles}
		          contentLabel="shopping cart Modal"
		          shouldCloseOnOverlayClick={false}
		          shouldCloseOnEsc={false}
		        >
		        <div className="fl w-100 tr">
		        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
		        </div>
		        	{modalContent}
					</Modal>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/container/EditPrize.js